"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatestRef = void 0;
const react_1 = require("react");
/**
 * Helpful when we want to use a value in an effect or useCallback,
 * but don't want to react to changes
 */
function useLatestRef(value) {
    const ref = (0, react_1.useRef)(value);
    (0, react_1.useEffect)(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
exports.useLatestRef = useLatestRef;
//# sourceMappingURL=use-latest-ref.js.map